import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {CommunicationContentSubstitutionModel} from '../../../api/model/communicationContentSubstitution.model';
import {
    CommunicationContentSubstitutionConverter
} from '../../../api/model/converter/communicationContentSubstitution.converter';

@Injectable({
    providedIn: 'root'
})
export class CommunicationContentSubstitutionDataService
    extends AbstractDataServiceV2<CommunicationContentSubstitutionModel, CommunicationContentSubstitutionConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: CommunicationContentSubstitutionConverter) {
        super('CommunicationContentSubstitution', http, httpUrlGenerator, logger, config, converter);
    }
}
